import React from 'react';
import { withTranslation } from 'react-i18next';
import { LocalStorageService, SignatureRequestService } from '../../../services';
import { QRSignedDocumentView } from '../../views';

class QRDocSignedAction extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  state = {
    loading: false,
    message: '',
    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    showWarningRequesting: false,
    namesignRequest: '',
    descriptionSignRequest: '',
    typeSignRequest: '',
    recordKeepingMessages: 'No aplica',
    timeStampSginReques: 'No aplica',
    dataGrid: [],
    proofOfLifeActive: false,
    documentGrid: []
  };

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  signatureRequestService = new SignatureRequestService(this.url);

  async componentDidMount() {
    this.toggleLoading(true)
    try {
      //get all info of signature request
      let signInfo = await this.signatureRequestService.getSIgngRequesOpenQR(this.props.sessionId, this.props.hash)
      if (signInfo && Number(signInfo.statusCode) === 200) {
        let dataBinnacle = []
        let proofOfLifeActive = signInfo.data.eventsBinnacle.some(item => item.proofOfLife)
        if (proofOfLifeActive) {
          for (let index = 0; index < signInfo.data.eventsBinnacle.length; index++) {
            let info = {}
            let nameUser = signInfo.data.eventsBinnacle[index].user ? signInfo.data.eventsBinnacle[index].user.firstName + ' ' + signInfo.data.eventsBinnacle[index].user.firstLastName : ''
            info.name = nameUser
            info.date = signInfo.data.eventsBinnacle[index].executionDate
            info.type = signInfo.data.eventsBinnacle[index].eventName
            if (info.proofOfLife) info.recognition = 'Exitoso'
            dataBinnacle.push(info)
          }
        } else {
          for (let index = 0; index < signInfo.data.eventsBinnacle.length; index++) {
            let info = {}
            let nameUser = signInfo.data.eventsBinnacle[index].user ? signInfo.data.eventsBinnacle[index].user.firstName + ' ' + signInfo.data.eventsBinnacle[index].user.firstLastName : ''
            info.name = nameUser
            info.date = signInfo.data.eventsBinnacle[index].executionDate
            info.type = signInfo.data.eventsBinnacle[index].eventName
            dataBinnacle.push(info)
          }
        }

        let documentGridArray = signInfo.data.documents.map(doc => ({
          name: doc.name,
          type: 'Generado',
          date: doc.date,
          docType: doc.docType || 'pdfFile',
          url: doc.url,
          asn1Data: doc.asn1Data || null
        }))

        const timeStampSign = signInfo.data.documents.find(doc => doc.serviceId === Number(1))?.hash || 'No aplica'
        const keepMessage = signInfo.data.documents.find(doc => doc.serviceId === Number(2))?.hash || 'No aplica'

        this.setState({
          namesignRequest: signInfo.data.signRequestName,
          descriptionSignRequest: signInfo.data.signRequestDescription,
          typeSignRequest: signInfo.data.signatureTypeName,
          recordKeepingMessages: keepMessage,
          timeStampSginReques: timeStampSign,
          dataGrid: dataBinnacle,
          proofOfLifeActive,
          documentGrid: documentGridArray
        })
        this.toggleLoading(false)
      } else {
        this.toggleLoading(false)
        this.toggleErrorRequesting(true)
        setTimeout(() => {
          this.toggleErrorRequesting(false)
          window.location.href = '/'
        }, 2000)
      }
    } catch (error) {
      console.log(error)
      this.toggleLoading(false)
      this.toggleErrorRequesting(true)
      setTimeout(() => {
        this.toggleErrorRequesting(false)
        window.location.href = '/'
      }, 2000)
      return;
    }
  }

  //function loading
  toggleLoading = (value) => {
    this.setState({
      loading: value
    })
  }

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function completed dialog
  toggleCompletedRequesting = (value, message,) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: ''
          });
        }, 4000);
      }
    );
  };

  //Funtion error dialog
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
            message: '',
          });
        }, 4000);
      }
    );
  };

  //Funtion warning dialog
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
            message: '',
          });
        }, 4000);
      }
    );
  };


  render() {
    return (
      <QRSignedDocumentView
        {...this.state}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
        nameDocumentRequest={this.state.namesignRequest}
        resumeDocRequest={this.state.descriptionSignRequest}
        signType={this.state.typeSignRequest}
        hash={this.props.hash}
        recordConservation={this.state.recordKeepingMessages}
        timeStamp={this.state.timeStampSginReques}
        dataGrid={this.state.dataGrid}
      />
    );
  }
}

export default withTranslation()(QRDocSignedAction);
